import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import {
  fetchThemesList,
  clearThemesList,
} from 'redux/themes/actions';

import ThemesListItem
  from 'components/dashboard/appearance-content/ThemesListItem';
import CommonMessage from 'components/common/CommonMessage';

import './ThemesList.css';


class ThemesList extends Component {
  static propTypes = {
    fetchThemesList: PropTypes.func.isRequired,
    clearThemesList: PropTypes.func.isRequired,
    setPredefinedTheme: PropTypes.string.isRequired,
    setPredefinedStyles: PropTypes.string.isRequired,
    me: PropTypes.object,
    themesList: PropTypes.arrayOf(PropTypes.shape),
    themesListError: PropTypes.object,
  };

  static defaultProps = {
    me: null,
    themesList: null,
    themesListError: null,
  };

  componentDidMount() {
    if (!this.props.themesList) {
      this.props.fetchThemesList();
    }
  }

  onThemeChange = theme => {
    const { me } = this.props;
    if (theme.is_pro) {
      if (me && me.subscription && me.subscription.ff_background_image) {
        this.props.setPredefinedTheme(theme.id);
        this.props.setPredefinedStyles(theme.theme_class);
      }
    } else {
      this.props.setPredefinedTheme(theme.id);
      this.props.setPredefinedStyles(theme.theme_class);
    }
  };

  render() {
    const { me, themesList, themesListError } = this.props;

    return (
      <Translation>
        {(t) => (
          <div className="themes-list__component">
            {/* Custom Theme Selector */}
            <div
              className={`custom-theme-item${!me.theme ? ' active' : ''}`}
              onClick={this.props.setCustomMode}
              role="button"
              tabIndex={-1}
            >
              <div
                className={`checked-icon${!me.theme ? ' active' : ''}`}
              />
              <div className="wrapper" />
              <div
                className={`undertext${!me.theme ? ' active' : ''}`}
              >
                {t("Custom Theme")}
              </div>
            </div>

            {/* Themes List */}
            {themesList &&
              this.props.themesList.map(theme => (
                <ThemesListItem
                  key={`themes_list_item_key_${theme.id}`}
                  theme={theme}
                  me={me}
                  active={me.theme && me.theme.id === theme.id}
                  onClick={() => this.onThemeChange(theme)}
                />
              ))
            }

            {/* Themes List Error */}
            {themesListError &&
              <CommonMessage
                error
                errors={themesListError}
              />
            }
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    themesList: state.themesReducer.themesList,
    themesListError: state.themesReducer.themesListError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchThemesList,
    clearThemesList,
  },
)(ThemesList);
